import * as Actions from './inscription.actions';
export const InscriptionActions = Actions;
export { InscriptionState } from './inscription.state';
